export const productTabs = {
  produkt: 'Produkt',
  texts: 'Texts',
  medien: 'Medien',
  features: 'Features',
  bestelldetails: 'Bestelldetails',
  preislisten: 'Preislisten',
  logistik: 'Logistik',
  referenzen: 'Referenzen',
  udx: 'Udx',
  kategorien: 'Kategorien',
  electronicSales: 'ElectronicSales',
  displays: 'Displays',
  dpb: 'DPB',
  wawi: 'Wawi',
  recht: 'Recht',
  lieferanten: 'Lieferanten',
  shopware6: 'Shopware6',
  scireum: 'Scireum',
  einstellungen: 'Einstellungen',
  abverkaufszahlen: 'Abverkaufszahlen'
} as const;

export const customTabPrefix = 'tab:';

export function customTab(customTabId: number | string): string {
  return customTabPrefix + customTabId;
}
